import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portfolio-contact',
  templateUrl: './portfolio-contact.component.html',
  styleUrls: ['./portfolio-contact.component.scss']
})
export class PortfolioContactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
